module.exports = __webpack_public_path__ + "assets/images/industry_phase4.c4d105758557530c3d8848b57488c627.svg";